import "./DocsLayout.css"
import Layout from "../Layout";
import Logo from "../Logo";
import ToolBar from "../ToolBar";
import React, {MutableRefObject, useEffect, useRef} from "react";
import MainLeftMenu from "./MainLeftMenu";
import {ToolBarButtonType, toolBarStore} from "../../stores/ToolBarStore";
import docsService from "../../service/DocsService";
import {docsContentStore} from "../../stores/DocsContentStore";
import {observer} from "mobx-react-lite";

const additionalClass = "docs"

function DocsLayout() {
    toolBarStore.setButton(ToolBarButtonType.DOSC)

    const contentContainerRef: MutableRefObject<HTMLDivElement | null> = useRef(null)
    let contentContainerRefEl: HTMLDivElement

    useEffect(() => {
        if (contentContainerRef.current != null) {
            contentContainerRefEl = contentContainerRef.current
        } else {
            throw Error("error of initializing the content")
        }
        docsService
            .getContent("", "name")
            .then(r => docsContentStore.setContent(r))
    }, []);

    function handleMenuSelect(menuId: string, menuName: string) {
        docsService
            .getContent(menuId, menuName)
            .then(r => {
                docsContentStore.setContent(r)
                console.log(contentContainerRefEl.scrollTop)
                contentContainerRefEl.scrollTop = 0
            })
    }

    return (<>
        <Layout
            header={<>
                <Logo/>
                <ToolBar/>
            </>}
            leftSide={<MainLeftMenu
                topics={[
                    {code: "0", path: [], name: "Documentation"},
                    {code: "1", path: ["0"], name: "Main"},
                    {code: "2", path: ["0"], name: "sdfer 2"},
                    {code: "3", path: ["0"], name: "sdfer 3"},
                    {code: "4", path: ["0", "2"], name: "sdfer 4"},
                    {code: "5", path: ["0", "2"], name: "sdfer 5"},
                ]}
                onChange={handleMenuSelect}/>}
            leftSideClasses={[additionalClass]}

            body={<>
                <div ref={contentContainerRef} className={"content-wrapper"}>
                    <div className={"content"} dangerouslySetInnerHTML={{
                        __html: (docsContentStore.getContent() as string)
                    }}>
                    </div>
                </div>
            </>}
            bodyClasses={[additionalClass]}
        />
    </>)
}

export default observer(DocsLayout)